export { default as DefaultPage } from './DefaultPage';
export { default as FaqList } from './FaqList';



// WEBPACK FOOTER //
// ./src/features/faq/index.js